<template>
  <list :columns="columns" :modalCreate="modalCreate" :removeLink="removeLink" :cardLink="cardLink" :isUpdate="true"
    :isAdd="true" :itemLink="itemLink" :setLink="setLink" :openItem="false" :fields="fields" :searchDisable="true"
    @change="change" @changeFunction="changeFunction" v-model="val" />
</template>
<script>
export default {
  name: "products",
  props: ['id'],
  created() {
    this.itemLink = `business/groups/${this.id}/clients`;
    this.setLink = `business/groups/${this.id}/clients`;
  },
  methods: {
    changeFunction(val) { },
    change(val) { },

  },
  data() {
    return {
      val: [],
      modalCreate: "course_group",
      fields: [
        {
          col: 'col-12 col-md-6',
          label: "Выберите ученика",
          key: "client",
          type: "select",
          selectKey: "full_name",
          modal: "client",
          prefix: "group_client",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_client",
      itemLink: "",
      setLink: "",
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          disableLink: true,
        },
        {
          key: "full_name",
          title: "ФИО",
          checkbox: false,
          disableLink: true,
          object: 'position',
        },
        {
          key: "phone",
          title: "Номер телефона",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "pivot",
          title: "Зачислен",
          checkbox: false,
          disableLink: true,
          dateTimeFormat: true,
          object: 'join_at',
        },
        {
          key: "pivot",
          title: "Выбыл",
          checkbox: false,
          disableLink: true,
          dateTimeFormat: true,
          object: 'left_at',
        },
        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
